import * as React from 'react';
import * as classes from '@common/components/spinner/spinner.scss';

export const Spinner = () => (
  <div className={classes.wrapper}>
    <div className={classes.spinner} />
    <img className={classes.image} src="/assets/fnhw_wise_logos_purple.svg" />
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/spinner/spinner.component.tsx